import RouteEnum from "constants/RouteEnum";
import { RouteMapping } from "constants/RouteMapping";
import IAction from "models/IAction";
import IStore from "models/IStore";
import MenuPathModel from "models/MenuPathModel";
import React, { lazy } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { connect, DispatchProp } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { selectRequesting } from "selectors/requesting/RequestingSelector";
import IErrorState from "stores/error/models/IErrorState";
import MenuAction from "stores/menu/MenuAction";
import MenuModel from "stores/menu/models/MenuModel";
import ExternalAuthenticateRequestModel from "stores/utente/models/ExternalAuthenticateRequestModel";
import ExternalInfoModel from "stores/utente/models/ExternalInfoModel";
import UtenteAction from "stores/utente/UtenteAction";
import NavigationUtility from "utilities/NavigationUtility";
import Footer from "../footer/Footer";

const Menu = lazy(() => import("views/components/menu/Menu"));
const BaseContent = lazy(() => import("views/components/base-content/BaseContent"));
const NotFoundPage = lazy(() => import("views/not-found-page/NotFoundPage"));

interface IProps {}
interface IState {
    readonly sitePaths: MenuModel[];
}
interface IStateToProps {
    readonly isRequesting: boolean;
    readonly sitePaths: MenuModel[];
    readonly isMenuFullSize: boolean;
    readonly pathname: string;
    readonly authenticated: boolean;
    readonly externalInfo: ExternalInfoModel;
    readonly errors: IErrorState;
    readonly onSearchFocus: boolean;
    readonly embeddedMode: boolean;
}

const mapStateToProps = (state: IStore, ownProps: IProps): IStateToProps => ({
    isRequesting: selectRequesting(state, [UtenteAction.REQUEST_UTENTE_LOGIN_GET]),
    // isRequesting: false,
    sitePaths: state.menu.sitePaths,
    isMenuFullSize: state.utente.profilo.isMenuFullSize,
    pathname: state.router.location.pathname,
    authenticated: state.utente.authenticated,
    externalInfo: state.utente.externalInfo,
    errors: state.error,
    onSearchFocus: state.config.onSearchFocus,
    embeddedMode: state.config.embeddedMode,
});

class BasePath extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>) {
        super(props);
        this.state = {
            sitePaths: [],
        } as IState;
    }

    private hasUnmounted = false;

    public async componentDidMount() {
        //TODO: to recheck
        // const member = sessionStorage.getItem("member");
        // const abi = sessionStorage.getItem("abi");
        // console.log("BasePath member", member);
        // console.log("BasePath abi", abi);
        // const matricola: string = "79999";
        // const abi: string = "31934";
        // if (matricola && abi && this.checkIfUnauthorized(this.props.errors) === true) {
        //     const request = new ExternalAuthenticateRequestModel({
        //         username: "durantel",
        //         password: "durantel",
        //         member: Number(matricola),
        //         abi: abi,
        //         name: "luca",
        //         lastName: "durante",
        //         email: "luca.durante@linksmt.it",
        //         tokenCse: "noTokenCSE",
        //     });
        //     await this.props.dispatch(UtenteAction.externalAuthenticate(request));
        // }
    }

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private checkIfUnauthorized = (errors: IErrorState) => {
        let result = false;
        Object.keys(errors).forEach((error) => {
            const errorObj = errors[error].raw;
            if (errorObj && parseInt(errorObj.status) === 401) {
                result = true;
            }
        });
        return result;
    };

    private setLookupsAndViewModel = async () => {
        let sitePaths: MenuModel[] = await this.props.dispatch(MenuAction.pathsGet());
        if (this.hasUnmounted === false) {
            this.setState({
                sitePaths: sitePaths,
            });
        }
    };

    public render(): JSX.Element {
        const { isMenuFullSize, pathname, authenticated, embeddedMode, onSearchFocus } = this.props;
        const { sitePaths } = this.state;

        const isSidePage = NavigationUtility.checkIfIsSidePage(pathname);

        const accessoRoute = RouteMapping.find((item: MenuPathModel) => item.path === RouteEnum.ACCESSO);

        return (
            <>
                <div className={onSearchFocus ? "search-backdrop" : ""}></div>
                <Container
                    fluid
                    id={"main-content"}
                    className={[isSidePage ? "without-header" : "with-header", onSearchFocus ? "on-focus" : ""].join(
                        " "
                    )}
                >
                    <Row className="h-100">
                        {authenticated && !embeddedMode && <Menu />}
                        {!authenticated && (
                            <Col className="mt-5" sm={12}>
                                <Switch>
                                    <Route
                                        exact={accessoRoute?.exact}
                                        path={accessoRoute?.path}
                                        component={accessoRoute?.component}
                                    />
                                </Switch>
                            </Col>
                        )}
                        <Col
                            id="main-page"
                            xs={isSidePage || embeddedMode ? 12 : 10}
                            lg={isSidePage === false && isMenuFullSize === false ? 11 : undefined}
                            className={[
                                embeddedMode ? "px-0" : "px-0 pl-2",
                                isSidePage || embeddedMode ? "" : "offset-2",
                                isSidePage === false && isMenuFullSize === false ? "offset-lg-1" : "",
                            ].join(" ")}
                        >
                            {authenticated && (
                                <Switch>
                                    {RouteMapping.map((route: MenuPathModel, index: number) => (
                                        <Route
                                            key={index}
                                            exact={route.exact}
                                            path={route.path}
                                            component={route.component}
                                        />
                                    ))}

                                    {sitePaths && sitePaths.length > 0
                                        ? sitePaths.map((sitePath) => (
                                              <Route
                                                  key={sitePath.idVoceMenu}
                                                  exact={true}
                                                  path={"/" + sitePath.path}
                                                  component={() => (
                                                      <BaseContent
                                                          contentCode={sitePath.codiceContenuto}
                                                          positionId={sitePath.idElemento}
                                                      />
                                                  )}
                                              />
                                          ))
                                        : null}
                                    <Route component={NotFoundPage} />
                                </Switch>
                            )}
                        </Col>
                        <Footer />
                    </Row>
                </Container>
            </>
        );
    }
}

export { BasePath as Unconnected };
export default connect(mapStateToProps)(BasePath);
